import image1 from '@/assets/images/news/detail/20200813/1.jpeg';

export default {
  id: '20200813', //  模块 id
  title: '叮咚买菜推出“一顿吃光”系列 倡导勤俭节约的用餐理念', // 标题
  origin: '2020-08-13 16:25 来源：中国新闻网', // 新闻来源
  editor: '编辑：中国新闻网官方帐号', // 编辑者
  content: [
    {
      type: 0,
      text:
        '中新网8月13日电 “一粥一饭，当思来之不易”。勤俭节约，珍惜粮食是我国的传统美德，近年来，随着在线新经济的发展，许多消费者也开始在线上买菜解决家中的一日三餐。为了让消费者在体验便捷服务的同时，尽可能地减少食材浪费，叮咚买菜近日推出了“一顿吃光”系列产品，倡导勤俭节约的用餐理念与生活方式。      ',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '在许多人眼中，在家做饭就是为了吃得新鲜又放心。但和餐厅点餐一样，买菜也存在着买多买少的困扰：买少了不够吃，买多了又浪费。针对这个痛点，叮咚买菜基于消费大数据，筛选出消费者经常购买的食材搭配，并根据专业厨师建议进行份量配比，打造出“一顿吃光”系列产品。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据了解，叮咚买菜“一顿吃光”系列产品目前推出了第一期两款产品，包括地三鲜组合(600g/份)和家常蔬菜组合(400g/份)，在推出一个月以来，该系列受到许多家庭的青睐。数据显示，在上海该系列的销售量单日已经突破5000份，成为平台销量成长最快的品类之一。此外，叮咚买菜针对分量较小的调味品类也开发了类似的“小份装”贴心调味组合，以小份量装的葱段、姜、蒜头、小米椒组合来解决家庭做饭时的配料浪费问题。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“我们推出‘一顿吃光’系列的初衷，就是为了让消费者在每餐都吃得新鲜健康的同时，尽可能地减少食物浪费。”叮咚买菜商品运营负责人赵文涛介绍，推出该类组合产品的难度在于组合商品的份量需要多次打样炒食测评，同时，不同品类的商品包装在一起，部分商品很容易被挤压提高损耗，必须根据不同商品组合调整包装形式。      ',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“目前我们正在加紧开发‘一顿吃光’系列的更多新品。未来我们在蔬菜单品类组合的基础上，会推出跨品类的组合，例如蔬菜肉类组合、水果小份组合。”赵文涛表示。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜作为百姓的“在线”菜篮子，目前已为上海、北京、深圳等10个城市的2000万家庭用户提供最快29分钟送菜上门服务，日订单量突破60万单。在用户规模不断扩大的同时，叮咚买菜也一直利用大数据优势，根据用户购买习惯分析，进行各单品的分量、包装的动态调整，以最大化满足消费者需求，减少食材的损耗。',
      isIndent: false,
    },
  ],
};
